/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TagRegularRequest = {
    name: string;
    description?: string | null;
    emoji?: string | null;
    type?: TagRegularRequest.type;
    isCriteriaBased?: boolean;
};

export namespace TagRegularRequest {

    export enum type {
        COMPOSITE = 'composite',
        COMPANY_JOB = 'companyJob',
    }


}

